<script lang="ts">
  import { onMount, afterUpdate } from "svelte";

  export let max = 10;
  export let value = 0;

  let progress: HTMLDivElement;

  let w = 0;
  let pixelsPerStep = 0;

  $: {
    pixelsPerStep = w / max;
  }

  onMount(() => {
    pixelsPerStep = w / max;
    progress.style.width = `${pixelsPerStep * value}px`;
  });

  afterUpdate(() => {
    progress.style.width = `${pixelsPerStep * value}px`;
  });
</script>

<div bind:clientWidth={w} class="progress-container">
  <div bind:this={progress} class="progress" />
</div>

<style>
  .progress-container {
    height: 6px;
    background-color: #ffffff;
    width: 100%;
    max-width: 1015px;
    border-radius: 3px;
    overflow: hidden;
    margin: auto auto;
  }

  .progress {
    height: 100%;
    width: 0;
    background-color: #8d5fff;
    transition: width 0.4s ease-in-out;
  }
</style>
